import {
  GOOGLE_MAP_ID_DARK_2D,
  GOOGLE_MAP_ID_DARK_3D,
  GOOGLE_MAP_ID_LIGHT_2D,
  GOOGLE_MAP_ID_LIGHT_3D,
  GOOGLE_MAP_ID_DRAWING,
} from '@env';

import { GoogleMapStyle } from '../enums';

export function toGoogleMapTypeId(style: GoogleMapStyle): google.maps.MapTypeId | string {
  switch (style) {
    case GoogleMapStyle.Light:
      return GOOGLE_MAP_ID_LIGHT_2D;

    case GoogleMapStyle.Dark:
      return GOOGLE_MAP_ID_DARK_2D;

    case GoogleMapStyle.Satellite:
      return GoogleMapStyle.Hybrid;

    case GoogleMapStyle.Dark3D:
      return GOOGLE_MAP_ID_DARK_3D;

    case GoogleMapStyle.Light3D:
      return GOOGLE_MAP_ID_LIGHT_3D;

    case GoogleMapStyle.Drawing:
      return GOOGLE_MAP_ID_DRAWING;

    case GoogleMapStyle.TERRAIN:
      return GoogleMapStyle.TERRAIN;

    default:
      return google.maps.MapTypeId.ROADMAP;
  }
}

export function fromGoogleMapTypeId(typeId: google.maps.MapTypeId | string): GoogleMapStyle {
  switch (typeId) {
    case 'dark':
      return GoogleMapStyle.Dark;

    case 'light':
      return GoogleMapStyle.Light;

    case GoogleMapStyle.Satellite:
    case GoogleMapStyle.Hybrid:
      return GoogleMapStyle.Satellite;

    case 'dark3d':
      return GoogleMapStyle.Dark3D;

    case 'light3d':
      return GoogleMapStyle.Light3D;

    case 'drawing':
      return GoogleMapStyle.Drawing;

    case 'terrain':
      return GoogleMapStyle.TERRAIN;

    default:
      return GoogleMapStyle.Light;
  }
}
